import { minTopupInterval, targetThroughput } from 'app/constants';
import { TopUpDto } from 'data';

const isBlank = (value: unknown): boolean => value == null || value === '';

/**
 * Returns an enabled top-up with interval/throughput guaranteed to be populated.
 * Empty values (undefined, null, empty string, cleared number input) are replaced
 * with the defaults symmetrically for both fields.
 */
export const ensureTopUpDefaults = (topUp?: TopUpDto): TopUpDto => ({
  ...topUp,
  enable: true,
  minTopupInterval: isBlank(topUp?.minTopupInterval) ? minTopupInterval : topUp?.minTopupInterval,
  targetThroughput: isBlank(topUp?.targetThroughput) ? targetThroughput : topUp?.targetThroughput,
});

/**
 * Normalizes top-up for an API payload: when disabled, the numeric fields are
 * stripped so a disabled top-up never carries stale/empty interval/throughput.
 */
export const normalizeTopUpForSubmit = (topUp?: TopUpDto): TopUpDto => (topUp?.enable ? topUp : { enable: false });
